import { ADICIONAR_FILTRO_EMPRESA } from '../types'

export default function adicionarFiltroEmpresa (filtro) {
  return {
    type: ADICIONAR_FILTRO_EMPRESA,
    payload: filtro
  }
}
